<template>
	<v-card 
		class="text-center mx-auto"
		:max-width="maxWidth"
		:width="width"
		flat
	>
		<!-- <v-app-bar density="compact" flat app absolute v-if="isVisible"> -->
		<!-- <v-app-bar density="compact" flat app fixed v-if="isVisible"> -->
		<!-- <v-app-bar density="compact" flat fixed v-if="visible">
			<v-app-bar-title class="font-weight-bolt text-secondary text-wrap text-center">
				{{ title }} <span v-if="item.changed"><v-icon icon="mdi-file-edit" size="x-small"></v-icon></span>
			</v-app-bar-title>
			<template v-slot:append>
				<v-btn icon="mdi-magnify"></v-btn>
				<v-btn icon="mdi-heart"></v-btn>
				<v-btn icon="mdi-dots-vertical"></v-btn>
			</template>
		</v-app-bar> -->

		<!-- <v-toolbar fixed>
			<template v-slot:title>
				{{ title }} <span v-if="item.changed"><v-icon icon="mdi-file-edit" size="x-small"></v-icon></span>
			</template>
		</v-toolbar> -->

		<!-- <v-card-item>
			<v-card-title class="font-weight-bolt text-secondary text-wrap text-center">
				{{ title }} <span v-if="item.changed"><v-icon icon="mdi-file-edit" size="x-small"></v-icon></span>
			</v-card-title>
			<v-card-subtitle :class="subtitleClass">
				{{ subtitle }}
			</v-card-subtitle>
		</v-card-item> -->
		<!-- <v-card-text>
			{{ text }}
		</v-card-text> -->
		<v-card-text>
			<z-photo ref="photo"
				v-model="item.files"
				:title="title"
				:required="item.required"
				:min="item.min"
				:max="item.max"
				:visible="visible"
				:changed="item.changed"
				@change="item.changed=true"
			></z-photo>
		</v-card-text>
	</v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import mixin from './mixin/main'
import zPhoto from '@/components/banners/Photo3'

export default {
	name: 'Component::Document',
	mixins: [mixin],
	components: { zPhoto },

	methods: {
		validate() {
			return this.$refs.photo?.validate()
		}
	},
}
</script>
